import {lazy, Suspense, useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import {getCookie} from "react-use-cookie";
import {setUser} from "@sentry/react";

import "./sentry";

import {API_ENDPOINTS} from "../../api/endpoints";
// const IndexPage = lazy(() => import("../../pages/IndexPage"));
import IndexPage from "../../pages/IndexPage";
import WarehousePage from "../../pages/WarehousePage";
// import ProjectPage from "../../pages/ProjectPage";
import {selectIsAuth} from "../../slices/UserSlice";
import {lazyRetry} from "../../utilities/lazyRetry";
import LoaderWholePage from "../../utilities/Loader/LoaderWholePage";
import UnderDevelopment from "../../utilities/UnderDevelopment/UnderDevelopment";
import LoginForm from "../authorization/LoginForm";
import PasswordForm from "../authorization/PasswordForm";
import Demo from "../conteiners/filters/Demo";
// import DemoTabs from "../conteiners/tabs/useTabs";
// import DemoComponent from "../conteiners/tabs/Demo";
import ErrorBoundary from "../errorBoundary/ErrorBoundary";
import SilentErrorListener from "../errorBoundary/SilentErrorListener";
import TemporarilyUnavailable from "../errorBoundary/TemporarilyUnavailable";
import MainPage from "../MainPage/MainPage";
import ModalProvider from "../Modal/ModalProvider";
import NavBar from "../NavBar/NavBar";

import TokenControl from "./TokenControl";

// import RoutineMaintenance from "../RoutineMaintenance/RoutineMaintenance";
import "react-toastify/dist/ReactToastify.css";
import "../../Styles/Buttons.scss";
import "../../Styles/List.scss";
import "../../Styles/Main.scss";
import "../Modal/modal.scss";
import "./App.css";
import "../../../src/Components/Project/ProjectAddForm/ProjectAddForm.scss";

const AdminPage = lazy(() => lazyRetry(() => import("../../pages/AdminPage")));
const CashdeskPage = lazy(() => lazyRetry(() => import("../../pages/CashdeskPage")));
const FinBlockPage = lazy(() => lazyRetry(() => import("../../pages/Finance/FinBlockPage")));
const KpPage = lazy(() => lazyRetry(() => import("../../pages/KpPage")));
const LogistPage = lazy(() => lazyRetry(() => import("../../pages/LogistPage")));
const ChangeLogPage = lazy(() => lazyRetry(() => import("../../pages/ChangeLogPage")));
const BazaDocsPage = lazy(() => lazyRetry(() => import("../../pages/BazaDocsPage")));
const SKUPage = lazy(() => lazyRetry(() => import("../../pages/SKUPage")));
const SkuVedPage = lazy(() => lazyRetry(() => import("../../pages/SkuVedPage")));
const ProjectPage = lazy(() => lazyRetry(() => import("../../pages/ProjectPage")));
const SystemPage = lazy(() => lazyRetry(() => import("../../pages/SystemPage")));

function App() {
  const {i18n} = useTranslation();
  const {user} = useSelector(state => state.user);
  const isAuth = useSelector(selectIsAuth);
  const token = getCookie("access_token");

  useEffect(() => {
    localStorage.setItem("language", i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    if (!user || (!user.id && !user.login)) {
      setUser(null);
      return;
    }

    setUser({
      id: user.id ? String(user.id) : undefined,
      username: user.login || undefined,
    });
  }, [user?.id, user?.login]);

  // const appHeight = useCallback(() =>{
  //   const doc = document.documentElement
  //   doc.style.setProperty('--app-height', `${window.innerHeight-30}px`)
  // },[])

  // useEffect(() => {
  //   appHeight()
  //   window.addEventListener('resize', appHeight)

  //   return () => window.removeEventListener("resize", appHeight);
  // }, [appHeight]);

  // const maintainanceTime = "2025-09-26T18:41:00+03:00";

  return (
    <Router>
      <ModalProvider>
        <div className="App">
          <TokenControl />
          <NavBar />
          {/* <RoutineMaintenance
              // maintainanceTime={maintainanceTime}
              // inProgress={5 * 60}
            /> */}
          <SilentErrorListener />
          <Suspense fallback={<LoaderWholePage />}>
            <Routes>
              <Route path="/ba3a/changeLog/*" element={<ChangeLogPage />} />
              <Route path="/ba3a/docs/*" element={<BazaDocsPage />} />
              <Route
                path="/ba3a"
                element={
                  <ErrorBoundary fallback={<div>The page is under maintainance</div>}>
                    <IndexPage />
                  </ErrorBoundary>
                }
              >
                <Route path="admin/*" element={<AdminPage />} />
                <Route path="main" element={<MainPage />} />
                <Route path="project/*" element={<ProjectPage />} />
                <Route path="co/*" element={<KpPage />} />
                <Route path="sku/*" element={<SKUPage />} />
                <Route path="fin-block/*" element={<FinBlockPage />} />
                <Route path="cashdesk/*" element={<CashdeskPage />} />
                <Route path="fin-accounting/*" element={<TemporarilyUnavailable />} />
                <Route path="fea/*" element={<SkuVedPage />} />
                <Route path="logistician/*" element={<LogistPage />} />
                <Route path="cashdesk/*" element={<CashdeskPage />} />
                <Route path={`${API_ENDPOINTS.SYSTEM.BASE}/*`} element={<SystemPage />} />
                <Route path={`${API_ENDPOINTS.WAREHOUSE.BASE}/*`} element={<WarehousePage />} />
              </Route>

              <Route path="demoC" element={<Demo />} />
              <Route
                path="/"
                element={
                  <ErrorBoundary>
                    <Navigate to="/login" />
                  </ErrorBoundary>
                }
              />
              <Route
                path="/login"
                element={
                  user && !isAuth && !token ? (
                    <ErrorBoundary>
                      <Navigate to="/password" />
                    </ErrorBoundary>
                  ) : (
                    <ErrorBoundary>
                      <LoginForm />
                    </ErrorBoundary>
                  )
                }
              />
              <Route
                path="/password"
                element={user && isAuth && token ? <Navigate to="/ba3a/main" /> : <PasswordForm />}
              />
              <Route path="/*" element={<UnderDevelopment />} />
            </Routes>
          </Suspense>
          <ToastContainer position="top-right" hideProgressBar />
        </div>
      </ModalProvider>
    </Router>
  );
}

export default App;
